export type { TagProps } from './Tag'
export { Tag, ExtendedTag } from './Tag'
